import { render } from "./MTKHeader.vue?vue&type=template&id=27cc9402&scoped=true"
import script from "./MTKHeader.vue?vue&type=script&lang=js"
export * from "./MTKHeader.vue?vue&type=script&lang=js"

import "./MTKHeader.vue?vue&type=style&index=0&id=27cc9402&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27cc9402"

export default script